import Statistics from './views/dashboard/keywords/statistics/statistics';

export const dictionary = {
  en: {
    shared: {
      change: 'Change',
      confirmation: 'Confirmation.',
      days: 'dag | days',
      edit: 'edit',
      loading: 'Loading ...',
      notSet: '(not set) | [Not Set Yet]',
      sec: 'sec',
      update: 'Update',
      contactAdmin: 'Contact Admin.',
    },
    time: {
      seconds: "\"",
      minutes: "':"
    },
    navigation: {
      console: 'Moderators\' Console',
      home: 'Main Menu',
      overview: 'Main Overview',
      keywords: 'Keywords',
      analytic: 'Analytics',
      channels: 'Channels',
      campaigns: 'Google Ads',
      toDoList: 'To-Do List',
      support: 'Support',
      settings: 'Settings',
      logout: 'Sign out',
      statistics: 'Statistics',
      rankings: 'Rankings',
      competitors: 'Competitors',
      cities: 'City',
      countries: 'Country',
      devices: 'Device',
      genders: 'Gender',
      ages: 'Age',
      hours: 'Hour'
    },
    errors: {
      datePicker: 'Dates are invalid',
      general: 'Something went wrong.',
      noData: 'No data available',
      noService: 'Please Select a Service',
      notAvailable: 'Not Available',
      loginFailure: 'Invalid login attempt',
      lockedout: 'This account has been locked out, please try again later.'
    },
    hints: {
      company: {
        match: 'Company\'s name is invalid, can only contain letters or digits.'
      },
      email: {
        match: 'Enter a valid Email.'
      },
      password: {
        match: 'Password must be at least 8 characters long. Contain at least 1 uppercase, 1 lowercase and 1 digit',
        matchNewPass: 'Password and confirm password do not match.'
      },
      username: {
        match: 'Username must be at least 5 and at max 50 characters long.'
      },
    },
    account: {
      forgot: {
        title: 'Forgot your password?',
      },
      login: {
        title: 'Sign in with your credentials',
      },
      register: {
        title: 'Create Account',
      },
      reset: {
        title: 'Create new Password',
        msg: 'Your password has been reset.'
      },
      activationExpired: 'Activation code has expired.',
      back: "Back to Login",
      company: 'Company\'s Name',
      email: 'Email',
      enterUsername: 'Enter your Username',
      name: 'Name',
      signin: 'Sign in | Sign in As',
      signout: 'Sign out',
      password: 'Password | Current Password | New Password',
      passwordConfirm: 'Confirm Password | Confirm New Password',
      resetConfirm: 'Please check your email to reset your password.',
      send: 'Send',
      username: 'Username',
    },
    analytics: {
      titles: ['Sessions', 'Page Views', 'Page Views Per Session', 'Average Sessions Duration', 'Goal Completions', 'Transactions Per Session', 'Transaction Revenue'],
      addTitles: ['Impressions', 'Clicks', 'CTR', 'CPC', 'Average Session Duration', 'Page Views Per Session', 'Goal Completions', 'Transactions Per Session', 'Transaction Revenue', 'Total Cost'],
      paidsearch: 'Paid Search',
      organicsearch: 'Organic Search',
      direct: 'Direct',
      referral: 'Referral',
      email: 'E-mail',
      social: 'Social',
      desktop: 'Desktop',
      mobile: 'Mobile',
      tablet: 'Tablet',
      female: 'Female',
      male: 'Male',
    },
    keywords: {
      statistics: {
        title: 'Statistics',
        placements: 'Total Placement Development',
        development: 'Keyword development',
        numkeywords: 'Number of Keyords',
        current: 'Current',
        directions: 'Up | Down',
      },
      rankings: {
        title: 'Rankings',
        headings: ['Keyword', 'Search Volume', 'Current Place', 'Project\'s Start'],
      },
      competitors: {
        title: 'Competitors',
        headings: ['Keyword', 'Search Volume'],
      },
      
    },
    manage: {
      settings: {
        title: 'Account Settings',
      },
    },
    overview: {
      analytics: {
        age: 'Age Brackets',
        avgPerViewsPerSes: 'Number of Page Views per Visitor',
        avgSesDuration: 'Time on Page per Visitor',
        grouping: 'Channel Grouping',
        city: 'Cities',
        sessions: 'Sessions',
        totalSessions: 'Number of Visitors',
      },
      serpbook: {
        extra: 'Extra Keywords',
        th1: 'Keyword', 
        th2: 'Search Volume', 
        th3: 'Current Place', 
        th4: 'Last Day | Lats 7 Days | Last 30 Days', 
        th5: 'Since Project\'s Start',
        th6: 'Project\'s Start',
      },
    },
  },
  sv: {
    shared: {
      change: 'Ändra',
      confirmation: 'Bekräftelse.',
      days: 'dag | dagar',
      edit: 'redigera',
      loading: 'Laddar ...',
      notSet: '(Okänd) | [Okänd]',
      sec: 'sek',
      update: 'Uppdatera',
      contactAdmin: 'Kontakta administratör.',
    },
    time: {
      seconds: "sek",
      minutes: "min "
    },
    navigation: {
      console: 'Moderator konsol',
      home: 'Huvudmeny',
      overview: 'Översikt',
      keywords: 'Sökord',
      analytic: 'Besökare',
      channels: 'Trafik',
      campaigns: 'Google Ads',
      toDoList: 'To-Do List',
      support: 'Support',
      settings: 'Inställningar',
      logout: 'Logga ut',
      statistics: 'Utveckling',
      rankings: 'Placering',
      competitors: 'Konkurrentöversikt',
      cities: 'Stad',
      countries: 'Land',
      devices: 'Enhet',
      genders: 'Kön',
      ages: 'Ålder',
      hours: 'Tid'
    },
    errors: {
      datePicker: 'Datum ogiltigt.',
      general: 'Något gick fel.',
      noData: 'Ingen data tillgänglig.',
      noService: 'Vänligen välj service.',
      notAvailable: 'Ej Tillgänglig.',
      loginFailure: 'Felaktigt inloggnings försök',
      lockedout: 'Det här kontot har blivit spärrat, var vänlig försök igen senare.'
    },
    hints: {
      company: {
        match: 'Företagsnamn är ogiltigt, kan bara innehålla bokstäver eller siffror.'
      },
      email: {
        match: 'Ange en giltig e-postadress.'
      },
      password: {
        match: 'Lösenordet måste vara minst 8 tecken långt. Innehålla minst 1 siffra, 1 stor och 1 liten bokstav.',
        matchNewPass: 'Angivet lösenord matchar inte'
      },
      username: {
        match: 'Användarnamnet måste vara minst 5 och max 50 tecken långt.'
      },
    },
    account: {
      forgot: {
        title: 'Glömt ditt lösenord?',
      },
      login: {
        title: 'Logga in med ditt konto',
      },
      register: {
        title: 'Skapa ditt konto',
      },
      reset: {
        title: 'Skapa nytt lösenord',
        msg: 'Ditt lösenord har blivit återställt.',
      },
      activationExpired: 'Aktiveringskod ej giltig.',
      back: "Tillbax till Inloggning",
      company: 'Företagsnamn',
      email: 'Epost',
      enterUsername: 'Fylli ditt användarnamn',
      name: 'Namn',
      signin: 'Logga in | Logga in som',
      signout: 'Logga ut',
      password: 'Lösenord | Nuvarande Lösenord | Nytt Lösenord',
      passwordConfirm: 'Bekräfta lösenord | Bekräfta ditt nya lösenord',
      resetConfirm: 'En återställningslänk för ditt lösenord har skickats till den e-postadress du har angivit.',
      send: 'Skicka',
      username: 'Användarnamn',
    },
    analytics: {
      titles: ['Sessioner', 'Sidvisningar', 'Sidvisningar per session', 'Genomsnittstid per session', 'Konverteringar', 'Konverteringar per session', 'Intäkter'],
      addTitles: ['Visningar', 'Besökare', 'Klickfrekvens', 'Kostnad per klick', 'Genomsnittstid per session', 'Sidvisningar per session', 'Konverteringar', 'Konverteringar per session', 'Intäkter', 'Totala kostnader'],
      paidsearch: 'Betald trafik',
      organicsearch: 'Organisk trafik',
      direct: 'Direkt trafik',
      referral: 'Övrig trafik',
      email: 'E-post',
      social: 'Sociala medier',
      desktop: 'Dator',
      mobile: 'Telefon',
      tablet: 'Surfplatta',
      female: 'Kvinna',
      male: 'Man',
    },
    keywords: {
      statistics: {
        title: 'Utveckling',
        placements: 'Placeringsutveckling sedan projektstart',
        development: 'Sökordsutveckling',
        numkeywords: 'Antal sökord',
        current: 'Nuvarande',
        directions: 'Upp | Ner',

      },
      rankings: {
        title: 'Placering',
        headings: ['Sökord', 'Sökvolym', 'Aktuell placering', 'Projektstart'],
      },
      competitors: {
        title: 'Konkurentöversikt',
        headings: ['Sökord', 'Sökvolym'],
      },
      
    },
    manage: {
      settings: {
        title: 'Kontoinställningar',
      },
    },
    overview: {
      analytics: {
        age: 'Ålder',
        avgPerViewsPerSes: 'Antal sidvisningar per besökare',
        avgSesDuration: 'Tid på sidan per besökare',
        grouping: 'Trafik',
        city: 'Städer',
        sessions: 'Antal besökare',
        totalSessions: 'Antal besökare',
      },
      serpbook: {
        extra: 'Extra sökord',
        th1: 'Sökord', 
        th2: 'Sökvolym', 
        th3: 'Aktuell placering', 
        th4: 'Senaste dagen | Senaste 7 dagarna | Senaste 30 dagarna', 
        th5: 'Sedan projektstart',
        th6: 'Projektstart',
      },
    },
  },
  
}